<h2 class="page-title">
  <span i18n="@@listado-de-alumnos">Listado de alumnos</span>
  @if (is_showing_all_alumnis()) {
    &nbsp;<span i18n="@@todos">(Todos)</span>
  } @else { 
    &nbsp;<span i18n="@@registrados">registrados</span>
  }
</h2>

<section class="page-body">

  <ng-template #stdFilter let-col_name="col_name">
    <mat-form-field appearance="outline" class="filter" style="width: 100%;">
      <!--<pre>{{col_name}}: |{{col_filter[col_name]}}|</pre>-->
      <input matInput
        [ngModel]="col_filter[col_name]" 
        (keyup)="checkfilter($event, col_name)" 
        placeholder="">
      <button matSuffix mat-icon-button aria-label="Clear" [disabled]="col_filter[col_name]===''"
        (click)="$event.stopPropagation();col_filter[col_name]='';checkfilter($event, col_name)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </ng-template>
  <ng-template #boolSiNoFilter let-col_name="col_name">
    <mat-form-field appearance="outline" class="filter" style="width: 100%;">
      <input matInput [ngModel]="col_filter[col_name]" (keyup)="checkfilterBoolSiNo($event, col_name);"
        style="display: none;" placeholder="">
      <!--<pre>col_filter[{{col_name}}]={{col_filter[col_name]}}</pre>-->
      <mat-slide-toggle [ngModel]="col_filter[col_name]" [ngClass]="{
                                    'active-true': col_filter[col_name]===true,
                                    'active-false': col_filter[col_name]===false
                              }" (change)="checkfilterBool($event, this, col_name)">
        <mat-label>
          @if (col_filter[col_name]==='') {
          <span i18n></span>
          }
          @if (col_filter[col_name]===false) {
          <span i18n>No</span>
          }
          @if (col_filter[col_name]===true) {
          <span i18n>Sí</span>
          }
        </mat-label>
      </mat-slide-toggle>
      @if (col_filter[col_name]!=='') {
      <button matSuffix mat-icon-button aria-label="Clear"
        (click)="col_filter[col_name]='';checkfilterBool($event, this, col_name, true)">
        <mat-icon>close</mat-icon>
      </button>
      }
    </mat-form-field>
  </ng-template>
  <ng-template #optionsListFilter let-col_name="col_name" let-label="label" let-options_list="options_list">
    <mat-form-field appearance="outline" floatLabel="auto">
      <mat-label>{{label}}</mat-label>
      <mat-select (selectionChange)="checkfilter($event, col_name)">
        <mat-option value=""></mat-option>
        @for (item of options_list; track item) {
        <mat-option [value]="item.description">
          {{item.description}}
        </mat-option>
        }
      </mat-select>
      <button matSuffix mat-icon-button aria-label="Clear"
        (click)="$event.stopPropagation();col_filter[col_name]='';checkfilter($event, col_name)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </ng-template>
  <ng-template #optionsListFilterString let-col_name="col_name" let-label="label" let-options_list="options_list">
    <mat-form-field appearance="outline" floatLabel="auto">
      <!--<mat-label>{{label}}</mat-label>-->
      <mat-select (selectionChange)="checkfilter($event, col_name)">
        @for (item of options_list; track item) {
        <mat-option [value]="item">
          {{item}}
        </mat-option>
        }
      </mat-select>
      optionsListFilter
    </mat-form-field>
  </ng-template>
  <ng-template #boolField1 let-field_label="label" let-field_formname="formname">
    @if (!forbidden_columns.includes(field_formname)) {
    <mat-slide-toggle [formControlName]="field_formname">
      <mat-label>{{field_label}}</mat-label>
    </mat-slide-toggle>
    }
  </ng-template>

  <nav class="actions">
          <!-- <code>Read only: {{read_only|json}}</code> -->
          <!-- <code>Admin: {{is_admin|json}}</code> -->
    <div>

      <button color="primary" mat-flat-button [matMenuTriggerFor]="menu_columns">
        <mat-icon>playlist_add</mat-icon><span i18n="@@seleccion-columnas">Selección columnas</span>
      </button>
      <mat-menu #menu_columns="matMenu">
        <column-selector [columns]="all_columns" [default]="default_displayed_columns" [selected]="displayed_columns"
          (onChange)="onColumnsChange($event)"></column-selector>
      </mat-menu>

      @if (this.is_admin) {
        <!-- <button color="primary" mat-flat-button [matMenuTriggerFor]="menu_export">
          <mat-icon>download</mat-icon><span i18n="@@exportar">Exportar</span>
        </button>
        <mat-menu #menu_export="matMenu" xPosition="after">
          <a mat-menu-item href="#" (click)="onExportAllData($event)" download="alumnis-todas.csv">
            <span i18n>Exportar todos los datos</span>
          </a>
          <a mat-menu-item href="#" (click)="onExportFilteredData($event)" download="alumnis-filtradas.csv">
            <span i18n>Exportar datos filtrados</span>
          </a>
        </mat-menu> -->
        
        <!-- <button color="primary" mat-flat-button (click)="fileUpload.click()">
          <mat-icon>file_upload</mat-icon><span i18n>Importar</span>
        </button>
        <input type="file" class="file-input" accept="text/csv" (change)="onImportData($event)" #fileUpload>
        @if (upload_progress) {
          <mat-progress-bar class="progress-bar" mode="determinate" color="primary" [value]="upload_progress">
          </mat-progress-bar>
        } -->
        @if (is_showing_all_alumnis()) {
          <button color="primary" mat-flat-button (click)="_refreshListData()">
            <mat-icon>visibility</mat-icon><span i18n="@@ver registados">Ver registrados</span>
          </button>
        } @else { 
          <button color="primary" mat-flat-button (click)="readAllAlumnis()">
            <mat-icon>visibility</mat-icon><span i18n="@@Ver todos los alumnis">Ver todos los alumnis</span>
          </button>
        }

        <button color="primary" mat-flat-button (click)="onCreateNew()">
          <mat-icon>add</mat-icon><span i18n="@@crear nuevo">Crear nuevo</span>
        </button>
      } @else {
      }
    </div>
  </nav>

  <div class="list-container">
    <mat-paginator #paginatorTop aria-label="Select page " 
        [pageSizeOptions]="page_size_options"
        showFirstLastButtons>
    </mat-paginator>


    <table mat-table matSort [dataSource]="list_data" class="list_data">
      <!-- columns -->
      <ng-container matColumnDef="id_alumnis">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head id-cell">
          <span i18n="@@id">Id</span>
        </th>
        <td mat-cell [ngClass]="{'warning': element.fecha_pendiente}" *matCellDef="let element"
          class="cell-row id-cell">{{element.id_alumnis}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="nombre">  
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head nombre-cell-head order-cell">
          <span i18n="@@nombre">Nombre</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row nombre-cell-row order-cell"> {{element.nombre}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="apellido1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head apellido1-cell">
          <span i18n="@@apellido1">Apellido 1</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row apellido1-cell"> {{element.apellido1}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="apellido2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head apellido2-cell">
          <span i18n="@@apellido2">Apellido 2</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row apellido2-cell"> {{element.apellido2}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="dni">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head dni-cell-head">
          <span i18n="@@cif_dni">C.I.F. / D.N.I.</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row dni-cell">{{element.dni}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>      
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head email-cell">
          <span i18n="@@email">e-Mail</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row email-cell"> {{element.email}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="telefono">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head telefono-cell">
          <span i18n="@@telefono">Teléfono</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row telefono-cell"> {{element.telefono}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="cargo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head cargo-cell">
          <span i18n="@@cargo">Cargo</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row cargo-cell"> {{element.cargo}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="ano_master">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head ano_master-cell">
          <span i18n="@@ano_master">Año Master</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row ano_master-cell"> {{element.ano_master}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="tipo_empresa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head tipo_empresa-cell-head">
          <span i18n="@@tipo_empresa">Tipo empresa</span>
        </th>
        <td mat-cell *matCellDef="let element"
          class="cell-row tipo_empresa-cell">{{element.tipo_empresa}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="empresa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head dni-empresa-head">
          <span i18n="@@nombre_empresa">Nombre empresa</span>
        </th>
        <td mat-cell [ngClass]="{'warning': element.fecha_pendiente}" *matCellDef="let element"
          class="cell-row empresa-cell">{{element.empresa}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="nif_empresa">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head nif_empresa-head">
          <span i18n="@@nif_empresa">NIF</span>
        </th>
        <td mat-cell [ngClass]="{'warning': element.fecha_pendiente}" *matCellDef="let element"
          class="cell-row nif_empresa-cell">{{element.nif_empresa}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="apellidos">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head apellidos-cell">
          <span i18n="@@apellidos">Apellidos</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row apellidos-cell"> {{element.apellidos}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="direccion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head direccion-head">
          <span i18n="@@direccion">Dirección</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row direccion-cell">{{element.direccion}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="ciudad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head ciudad-cell-head">
          <span i18n="@@ciudad">Ciudad</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row ciudad-cell">{{element.ciudad}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="codigo_postal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head codigo_postal-head columm-5">
          <span i18n="@@codigo_postal">Código postal<br />empresa</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row codigo_postal-cell column-5" columm-5>{{element.codigo_postal}}</td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>      
      <ng-container matColumnDef="especializacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head especializacion-cell">
          <span i18n="@@especializacion">Especialización</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row especializacion-cell"> {{element.especializacion}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="fecha_alta">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head fecha_alta-cell column-10">
          <span i18n="@@fecha_alta">Fecha alta</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row fecha_alta-cell column-10"> {{element.fecha_alta|date:'dd/MM/yyyy'}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="num_colegiado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head num_colegiado-cell-head column-10">
          <span i18n="@@num_colegiado">N. colegiado</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row num_colegiado-cell column-10"> {{element.num_colegiado}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="fecha_registro">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="cell-head fecha_registro-cell column-10">
          <span i18n="@@fecha_registro">Fecha registro</span>
        </th>
        <td mat-cell *matCellDef="let element" class="cell-row fecha_registro-cell column-10"> {{element.fecha_registro|date:'short'}} </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="command_cell">
        <th mat-header-cell *matHeaderCellDef class="cell-head command-cell-head"> <span i18n>Comandos</span> </th>
        <td mat-cell *matCellDef="let element"
          class="cell-row command-cell-row">
          @if (read_only) {
            <div>
              <button mat-icon-button color="primary" aria-label="Ver" i18n-aria-label matTooltip="Ver alumno"
                [disabled]="false" (click)="onEdit(element)">
                <mat-icon>visibility</mat-icon>
              </button>
            </div>
          } @else {
            <div>
              <button mat-icon-button color="primary" aria-label="Edit" i18n-aria-label [disabled]="false"
                (click)="onEdit(element)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
            <div>
              <button mat-icon-button color="warn" aria-label="Delete" i18n-aria-label matTooltip="Borrar alumno"
                [disabled]="false" (click)="onDelete(element)">
                <mat-icon class="mat-warn">delete</mat-icon>
              </button>
            </div>
          }
        </td>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <!-- =============================================================== -->
      <!-- Filters -->
      <ng-container matColumnDef="fid_alumnis">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container
            *ngTemplateOutlet="stdFilter;context:{col_name:'id_alumnis', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fnombre">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'nombre', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fapellido1">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'apellido1', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fapellido2">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'apellido2', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fdni">
        <th mat-header-cell *matHeaderCellDef class="filter-head dni-cell-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'dni', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="femail">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'email', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="ftelefono">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'telefono', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fcargo">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'cargo', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fano_master">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'ano_master', type:'input'}"></ng-container>
        </th>
      </ng-container>
      <ng-container matColumnDef="ftipo_empresa" class="filter-head">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container
            *ngTemplateOutlet="stdFilter;context:{col_name:'tipo_empresa', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fempresa">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <!-- <ng-container *ngTemplateOutlet="optionsListFilter;context:{
                              label: 'Seleccione empresa',
                              col_name:'empresa', 
                              options_list: lista_empresas
                              }"></ng-container><br /> -->
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'empresa', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fnif_empresa">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container
            *ngTemplateOutlet="stdFilter;context:{col_name:'nif_empresa', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fdireccion" class="filter-head">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'direccion', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fciudad" class="filter-head cell-filter">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'ciudad', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fcodigo_postal" class="filter-head">
        <th mat-header-cell *matHeaderCellDef class="cell-filter column-5">
          <ng-container
            *ngTemplateOutlet="stdFilter;context:{col_name:'codigo_postal', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fespecializacion">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'especializacion', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fapellidos">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'apellidos', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fnum_colegiado">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'num_colegiado', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="ffecha_registro">
        <th mat-header-cell *matHeaderCellDef class="filter-head">
          <ng-container *ngTemplateOutlet="stdFilter;context:{col_name:'fecha_registro', type:'input'}"></ng-container><br />
        </th>
      </ng-container>
      <ng-container matColumnDef="fcommand_cell">
        <th mat-header-cell *matHeaderCellDef></th>
      </ng-container>

      <!-- =============================================================== -->
      <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
      <tr mat-header-row *matHeaderRowDef="displayed_column_filters"></tr>
      <tr mat-row *matRowDef="let row; columns: displayed_columns;" [ngClass]="'warning'"></tr>
      <tr mat-footer-row *matFooterRowDef="displayed_columns"></tr>

    </table>

    <mat-paginator #paginatorBottom aria-label="Select page " 
        [pageSizeOptions]="page_size_options" 
        showFirstLastButtons>
    </mat-paginator>

  </div>  

</section>